import { store } from 'data/store'

export const SVUOTA_FILTRI_CERCA_PAZIENTE = () => {
    store.dispatch({
        type: 'SVUOTA_FILTRI_CERCA_PAZIENTE',
        payload: '',
    })
}
